export default __webpack_public_path__ + "static/media/Patients_Normal.aef20ec9.svg";